import classNamesOriginal, { Argument } from 'classnames';
import { overrideTailwindClasses } from 'tailwind-override';

export const convertToHUF = (amount: number) =>
  new Intl.NumberFormat('hu-HU', {
    style: 'currency',
    currency: 'HUF'
  }).format(amount);

export const mergeClassNames = (...args: Argument[]) =>
  overrideTailwindClasses(classNamesOriginal(...args));

// TODO - better typing (eg. return type)
/**
 * Function to look up with a string path the value of an object key N levels down.
 * @param obj any object
 * @param path string path with . separator, eg: 'billing.zip'
 * @returns the value if found the path in {@link obj}, undefined otherwise
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getDeepValue = <T extends Record<string, any>, K extends keyof T>(
  obj: T,
  path: string
): T[K] =>
  path
    .split('.')
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce<any>(
      (acc, val) =>
        typeof acc === 'object' && acc !== null && Object.hasOwnProperty.call(acc, val)
          ? acc[val]
          : undefined,
      obj
    );
